import gql from 'graphql-tag';

export const GET_GROUP_AFFILIATION_PROMOTION =
  process.env.__FF_GROUP_AFFILIATION_PROMOTION_QUERY_UPDATE__ === 'true'
    ? gql`
  query getGroupAffiliationPromotion($storeCode: String!) {
    promotion {
      groupAffiliationPromotion(storeCode: $storeCode) {
        applied
        eligibleGroups
        hasPriority
        promotion {
          title
          description
          detailsUrl
          discount {
            formattedValue
          }
          firedMessages
        }
        verificationDiscountAppliedMessage
        verificationSuccessMessage
        verificationSuccessTooltipMessage
        verifiedGroup
        willBeApplied
      }
    }
  }
`
    : gql`
  query getGroupAffiliationPromotion($storeCode: String!) {
    promotion {
      groupAffiliationPromotion(storeCode: $storeCode) {
        applied
        eligibleGroups
        promotion {
          title
          description
          detailsUrl
          discount {
            formattedValue
          }
          firedMessages
        }
        verificationDiscountAppliedMessage
        verificationSuccessMessage
        verificationSuccessTooltipMessage
        verifiedGroup
        willBeApplied
      }
    }
  }
`;
